module.exports = __webpack_public_path__ + "img/58.3.TP.711155f5.png";